export const headData = [
  {
    key: 'index',
    content: 'S.No.',
    isSortable: false,
    width: 4,
  },
  {
    key: 'firstName',
    content: 'First Name',
    isSortable: true,
    width: 12,
  },
  {
    key: 'lastName',
    content: 'Last Name',
    isSortable: true,
    width: 12,
  },
  {
    key: 'age',
    content: 'Age',
    isSortable: true,
    width: 4,
  },
  {
    key: 'company',
    content: 'Company',
    isSortable: false,
    width: 16,
  },
  {
    key: 'bloodGroup',
    content: 'Blood Group',
    isSortable: false,
    width: 8,
  },
  {
    key: 'email',
    content: 'Email',
    isSortable: false,
    width: 16,
  },
  {
    key: 'phone',
    content: 'Phone',
    isSortable: false,
    width: 12,
  },
  {
    key: 'gender',
    content: 'Gender',
    isSortable: false,
    width: 8,
  },
  {
    key: 'details',
    content: 'Details',
    isSortable: false,
    width: 8,
  },
];

export const bloodGroupOptions = [
  { label: 'A+', value: 'A+' },
  { label: 'A-', value: 'A−' },
  { label: 'B+', value: 'B+' },
  { label: 'B-', value: 'B−' },
  { label: 'O+', value: 'O+' },
  { label: 'O-', value: 'O−' },
  { label: 'AB+', value: 'AB+' },
  { label: 'AB-', value: 'AB−' },
];

export const universityOptions = [
  {
    label: 'Academy of Humanities and Economics in Lodz',
    value: 'Academy of Humanities and Economics in Lodz',
  },
  {
    label: 'Altai State Technical University',
    value: 'Altai State Technical University',
  },
  {
    label: 'Azerbaijan Medical University',
    value: 'Azerbaijan Medical University',
  },
  {
    label: 'Bashkir State Medical University',
    value: 'Bashkir State Medical University',
  },
  {
    label: 'California Coast University',
    value: 'California Coast University',
  },
  {
    label: 'Capital University of Medical Sciences',
    value: 'Capital University of Medical Sciences',
  },
  {
    label: 'Capitol University',
    value: 'Capitol University',
  },
  {
    label: 'Centro Universitário Adventista de São Paulo',
    value: 'Centro Universitário Adventista de São Paulo',
  },
  {
    label: 'Cevro Institut College',
    value: 'Cevro Institut College',
  },
  {
    label: 'Chongqing Telecommunication College',
    value: 'Chongqing Telecommunication College',
  },
  {
    label: 'Dallas Christian College',
    value: 'Dallas Christian College',
  },
  {
    label: 'Dongbei University of Finance And Economics',
    value: 'Dongbei University of Finance And Economics',
  },
  {
    label: 'Donghua University, Shanghai',
    value: 'Donghua University, Shanghai',
  },
  {
    label: 'Escuela Agricola Panamericana Zamorano',
    value: 'Escuela Agricola Panamericana Zamorano',
  },
  {
    label: 'Estonian University of Life Sciences',
    value: 'Estonian University of Life Sciences',
  },
  {
    label: "Fuji Women's College",
    value: "Fuji Women's College",
  },
  {
    label: 'Fukushima Medical College',
    value: 'Fukushima Medical College',
  },
  {
    label: 'Gotland University College',
    value: 'Gotland University College',
  },
  {
    label: 'Goucher College',
    value: 'Goucher College',
  },
  {
    label: 'Hainan University',
    value: 'Hainan University',
  },
  {
    label: 'Harbin Engineering University',
    value: 'Harbin Engineering University',
  },
  {
    label: 'Ho Chi Minh City University of Transport',
    value: 'Ho Chi Minh City University of Transport',
  },
  {
    label: 'Hodeidah University',
    value: 'Hodeidah University',
  },
  {
    label: 'Huaihua Medical College',
    value: 'Huaihua Medical College',
  },
  {
    label: 'Institut Sains dan Teknologi Al Kamal',
    value: 'Institut Sains dan Teknologi Al Kamal',
  },
  {
    label: 'Institut Teknologi Sepuluh Nopember',
    value: 'Institut Teknologi Sepuluh Nopember',
  },
  {
    label: 'Institut des Sciences de la Matière et du Rayonnement',
    value: 'Institut des Sciences de la Matière et du Rayonnement',
  },
  {
    label: 'Instituto Politécnico de Coimbra',
    value: 'Instituto Politécnico de Coimbra',
  },
  {
    label: 'Instituto Tecnológico de Santo Domingo',
    value: 'Instituto Tecnológico de Santo Domingo',
  },
  {
    label: 'International University Institute of Luxembourg',
    value: 'International University Institute of Luxembourg',
  },
  {
    label: 'Islamic Azad University, Janah',
    value: 'Islamic Azad University, Janah',
  },
  {
    label: 'Jiangxi Agricultural University',
    value: 'Jiangxi Agricultural University',
  },
  {
    label: 'Judson College Marion',
    value: 'Judson College Marion',
  },
  {
    label: 'Kiev Slavonic University',
    value: 'Kiev Slavonic University',
  },
  {
    label: 'Károl Gáspár University of the Reformed Church',
    value: 'Károl Gáspár University of the Reformed Church',
  },
  {
    label: 'Liepaja Pedagogical Higher School',
    value: 'Liepaja Pedagogical Higher School',
  },
  {
    label: 'Luhansk Taras Shevchenko National Pedagogical University',
    value: 'Luhansk Taras Shevchenko National Pedagogical University',
  },
  {
    label: 'Melaka City Polytechnic',
    value: 'Melaka City Polytechnic',
  },
  {
    label: 'Mendel University of Agriculture and Forestry',
    value: 'Mendel University of Agriculture and Forestry',
  },
  {
    label: 'Moraine Valley Community College',
    value: 'Moraine Valley Community College',
  },
  {
    label: 'Nanjing University of Economics',
    value: 'Nanjing University of Economics',
  },
  {
    label: 'Nanjing University of Traditional Chinese Medicine',
    value: 'Nanjing University of Traditional Chinese Medicine',
  },
  {
    label: 'Notre Dame University',
    value: 'Notre Dame University',
  },
  {
    label: 'Okinawa Prefectural University of Fine Arts',
    value: 'Okinawa Prefectural University of Fine Arts',
  },
  {
    label: 'PTPL College',
    value: 'PTPL College',
  },
  {
    label: 'Politeknik Negeri Jakarta',
    value: 'Politeknik Negeri Jakarta',
  },
  {
    label: 'Politeknik Negeri Lhokseumawe',
    value: 'Politeknik Negeri Lhokseumawe',
  },
  {
    label: 'Poznan School of Banking',
    value: 'Poznan School of Banking',
  },
  {
    label: "Queen's University",
    value: "Queen's University",
  },
  {
    label: 'San Beda College',
    value: 'San Beda College',
  },
  {
    label: 'Science University of Tokyo',
    value: 'Science University of Tokyo',
  },
  {
    label: 'Shenyang Pharmaceutical University',
    value: 'Shenyang Pharmaceutical University',
  },
  {
    label: 'Sichuan Normal University',
    value: 'Sichuan Normal University',
  },
  {
    label: 'St.Cyril and Methodius University',
    value: 'St.Cyril and Methodius University',
  },
  {
    label: 'Stavropol State Technical University',
    value: 'Stavropol State Technical University',
  },
  {
    label: 'Sultanah Bahiyah Polytechnic',
    value: 'Sultanah Bahiyah Polytechnic',
  },
  {
    label: 'Södertörn University College',
    value: 'Södertörn University College',
  },
  {
    label: 'Technical University of Mining and Metallurgy Ostrava',
    value: 'Technical University of Mining and Metallurgy Ostrava',
  },
  {
    label: 'Texas Lutheran University',
    value: 'Texas Lutheran University',
  },
  {
    label: 'Tianjin University of Technology',
    value: 'Tianjin University of Technology',
  },
  {
    label: 'Universidad Cooperativa de Colombia',
    value: 'Universidad Cooperativa de Colombia',
  },
  {
    label: 'Universidad de La Salle, Bajío',
    value: 'Universidad de La Salle, Bajío',
  },
  {
    label: 'Universidade Aberta Lisboa',
    value: 'Universidade Aberta Lisboa',
  },
  {
    label: 'Universidade Estadual do Ceará',
    value: 'Universidade Estadual do Ceará',
  },
  {
    label: 'Universidade Federal de Ouro Preto',
    value: 'Universidade Federal de Ouro Preto',
  },
  {
    label: 'Universidade da Beira Interior',
    value: 'Universidade da Beira Interior',
  },
  {
    label: 'Universitas Bojonegoro',
    value: 'Universitas Bojonegoro',
  },
  {
    label: 'Universitas Darma Persada',
    value: 'Universitas Darma Persada',
  },
  {
    label: 'Universitas Diponegoro',
    value: 'Universitas Diponegoro',
  },
  {
    label: 'Universitas Jember',
    value: 'Universitas Jember',
  },
  {
    label: 'Universitas Komputer Indonesia',
    value: 'Universitas Komputer Indonesia',
  },
  {
    label: 'Universitas Mataram',
    value: 'Universitas Mataram',
  },
  {
    label: 'Universitas Nasional Jakarta',
    value: 'Universitas Nasional Jakarta',
  },
  {
    label: 'Universitas Proklamasi 45',
    value: 'Universitas Proklamasi 45',
  },
  {
    label: 'Universitas Trilogi',
    value: 'Universitas Trilogi',
  },
  {
    label: 'Universitas Wisnuwardhana',
    value: 'Universitas Wisnuwardhana',
  },
  {
    label: 'Universitat Rámon Llull',
    value: 'Universitat Rámon Llull',
  },
  {
    label: 'University Centre of the Westfjords',
    value: 'University Centre of the Westfjords',
  },
  {
    label: 'University of Bergen',
    value: 'University of Bergen',
  },
  {
    label: 'University of Cagayan Valley',
    value: 'University of Cagayan Valley',
  },
  {
    label: 'University of Eastern Philippines',
    value: 'University of Eastern Philippines',
  },
  {
    label: 'University of Ljubljana',
    value: 'University of Ljubljana',
  },
  {
    label: 'University of Mauritius',
    value: 'University of Mauritius',
  },
  {
    label: 'University of Perpetual Help, System Dalta',
    value: 'University of Perpetual Help, System Dalta',
  },
  {
    label: 'University of Sri Jayawardenapura',
    value: 'University of Sri Jayawardenapura',
  },
  {
    label: 'University of Western Macedonia',
    value: 'University of Western Macedonia',
  },
  {
    label: 'University of lloilo',
    value: 'University of lloilo',
  },
  {
    label: 'University of the Gambia',
    value: 'University of the Gambia',
  },
  {
    label: 'Université Paris Nanterre (Paris X)',
    value: 'Université Paris Nanterre (Paris X)',
  },
  {
    label: "Université d'Etat d'Haiti",
    value: "Université d'Etat d'Haiti",
  },
  {
    label: 'Université de Fianarantsoa',
    value: 'Université de Fianarantsoa',
  },
  {
    label: 'Université de Lomé',
    value: 'Université de Lomé',
  },
  {
    label: 'Wenzhou Medical College',
    value: 'Wenzhou Medical College',
  },
  {
    label: 'Wuhan Automobile Polytechnical University',
    value: 'Wuhan Automobile Polytechnical University',
  },
  {
    label: 'Wuhan University of Technology',
    value: 'Wuhan University of Technology',
  },
  {
    label: 'Xinjiang University',
    value: 'Xinjiang University',
  },
  {
    label: 'Yantai Education Institute & Yantai Television University',
    value: 'Yantai Education Institute & Yantai Television University',
  },
  {
    label: 'Yonok University',
    value: 'Yonok University',
  },
];

export const genderOptions = [
  { name: 'male', value: 'male', label: 'Male' },
  { name: 'female', value: 'female', label: 'Female' },
];
